import { Box, Divider, Drawer, List } from '@mui/material'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useBreakpoint from '~hooks/use-breakpoint'
import { useConstructLinkWithPool } from '~hooks/use-construct-link-with-pool'
import { OPEN_DRAWER_WIDTH } from '~hooks/use-nav-and-footer-constants'
import { useGetTabList } from '~hooks/queries/vessels/data/use-get-tab-list'
import { useConstructSubPages } from '~pages/pages-behind-login/financials/vessel-financials/hooks/use-construct-sub-pages'
import { COLORS } from '~theme/colors'
import { MenuItem } from '../../left-navigation/components/menu-item'
import {
  breakpointsWithHamburgerMenu,
  useNavigation,
} from '../../navigation-context'
import { DrawerHeader } from './primary-left-navigation'

export function SecondaryLeftNavigation() {
  const { isOpen, setIsOpen } = useNavigation()
  const { breakpoint } = useBreakpoint()
  const isMobileSize = breakpointsWithHamburgerMenu.includes(breakpoint)

  const { vesselId } = useParams()
  const { data: tabPermissions } = useGetTabList({ vesselId })
  const vesselFleetLinks =
    tabPermissions?.map((tab) => {
      return {
        label: tab.name,
        link: `/fleet/vessels/${vesselId}/${tab.path}`,
      }
    }) || []
  const vesselFinancialsMenuItems = useVesselFinancialsMenuItems()
  const financialsBackLink = useConstructLinkWithPool(
    '/financials/earnings/:pool',
  )
  const drawerWidth = isOpen && !isMobileSize ? OPEN_DRAWER_WIDTH : 0

  useEffect(() => {
    if (!isMobileSize && !isOpen) {
      setIsOpen(true)
    }
  }, [isMobileSize])

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Drawer
      anchor={!isMobileSize ? 'left' : 'top'}
      variant={isMobileSize ? 'temporary' : 'permanent'}
      onClose={handleClose}
      disableScrollLock
      slotProps={{ paper: { className: 'tour-step-nav-pane' } }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        ['& .MuiDrawer-paper']: {
          width: isMobileSize ? '100%' : drawerWidth,
          boxSizing: 'border-box',
        },
      }}
      open={isOpen}
    >
      <DrawerHeader />
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          marginTop: 0,
        }}
      >
        <List>
          <MenuItem
            link={
              location.pathname.startsWith('/fleet')
                ? '/fleet/vessels'
                : financialsBackLink
            }
            label={`Back to ${location.pathname.startsWith('/fleet') ? 'Fleet' : 'Pool Earnings'}`}
            isBackButton
          />
          <Divider sx={{ borderColor: COLORS.greys.ultraDark }} />
          {[...vesselFleetLinks, ...vesselFinancialsMenuItems].map((item) => (
            <MenuItem key={item.link} {...item} />
          ))}
        </List>
      </Box>
    </Drawer>
  )
}

function useVesselFinancialsMenuItems() {
  const { subPages } = useConstructSubPages()
  return subPages.map(({ title, ...rest }) => ({
    label: title,
    ...rest,
  }))
}
